import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { faChevronLeft } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import '../../assets/stylesheets/Units/Header.scss';
import { createBrowserHistory } from 'history';

const browserHistory = createBrowserHistory();
const Header = ({ title, className, onExcel, helpTo, backTo, onClose }) => {
    const { t } = useTranslation();
    const redirect = e => {
        if( !backTo ) {
            e.preventDefault();
            browserHistory.goBack();
        }
    }

    return(
        <div onClick={onClose} className={`dialogHeader ${className || ''}`}>
            {title &&
                <span className={'title'}>{t(title)}</span>
            }
            {onExcel ?
                (<span className="dialogHeaderExcel" onClick={onExcel}></span>) :
                false
            }
            <Link className={'arrowIcon'} to = { backTo } onClick={ e => redirect(e) }>
                <FontAwesomeIcon icon={faChevronLeft} color="white" className="fa chevron-left"></FontAwesomeIcon>
            </Link>
            {helpTo ?
                (<Link className="dialogHeaderHelp" to={helpTo}></Link>) :
                false
            }
        </div>
    )
}
export default Header;